import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  eventStatusList: null,
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "eventStatusListPage",
  initialState: initialState,
  reducers: {
    getEventStatusListPageData: (state, action) => {
      state.loading = true;
      state.error = null;
      state.dataFetched = false;
    },
    getEventStatusListPageDataSuccess: (state, action) => {
      state.error = null;
      state.loading = false;
      state.eventStatusList = action.payload.data?.data?.ACTION_LIST;
    },
    getEventStatusListPageDataError: (state, action) => {
      state.error = action.payload;
      state.eventStatusList = null;
      state.loading = false;
    },
    stopAllAction: (state, action) => {
      state.error = null;
      state.loading = true;
      state.eventStatusList = null;
    },
    stopAction: (state, action) => {
      state.error = null;
      state.loading = true;
      state.eventStatusList = null;
    },
    stopAllActionError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    stopActionError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    eventStatusListPageResetState: () => initialState,
  },
});

export const {
  getEventStatusListPageData,
  getEventStatusListPageDataSuccess,
  getEventStatusListPageDataError,
  stopAllAction,
  stopAction,
  stopAllActionError,
  stopActionError,
  eventStatusListPageResetState,
} = slice.actions;

export default slice.reducer;
